export default "__VITE_ASSET__2e870a5f__"